import React, { PropsWithChildren } from 'react'
import ds from 'views/styles/designSystem'
import { pxTo } from 'design-system-utils'
import { useFela } from 'react-fela'

interface ContainerProps {
  className?: string
}

export const Container: React.FC<PropsWithChildren<ContainerProps>> = ({ className, ...props }) => {
  const { css } = useFela()
  return <div {...props} className={[className, css(rules.container)].filter((s) => s).join(' ')} />
}

const rules = {
  container: () => ({
    padding: `0 ${pxTo(ds.get('layout.gutter') / 2, ds.get('type.baseFontSize'), 'rem')}`,
    margin: '0 auto',
    '@media (min-width: 768px) and (max-width: 991px)': {
      padding: 0,
      maxWidth: pxTo(ds.get('layout.maxWidth.sm'), ds.get('type.baseFontSize'), 'rem'),
    },
    '@media (min-width: 991px) and (max-width: 1280px)': {
      maxWidth: pxTo(ds.get('layout.maxWidth.md'), ds.get('type.baseFontSize'), 'rem'),
    },
    '@media (min-width: 1280px) and (max-width: 1440px)': {
      maxWidth: pxTo(ds.get('layout.maxWidth.lg'), ds.get('type.baseFontSize'), 'rem'),
    },
    '@media (min-width: 1440px)': {
      maxWidth: pxTo(ds.get('layout.maxWidth.xl'), ds.get('type.baseFontSize'), 'rem'),
    },
    '@media (min-width: 1600px)': {
      maxWidth: pxTo(ds.get('layout.maxWidth.xxl'), ds.get('type.baseFontSize'), 'rem'),
    },
  }),
}
